export default __webpack_public_path__ + "static/media/tf.c200af78.svg";